module.exports = __webpack_public_path__ + "pc/img/money_icon.567e3edc.png";